import * as React from "react";
import type { SVGProps } from "react";
const SvgAudioSettings02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M6.126 9.913H17.72c2.057 0 3.726-1.682 3.726-3.756 0-2.075-1.669-3.757-3.726-3.757H6.126m0 7.513C4.068 9.913 2.4 8.231 2.4 6.157 2.4 4.082 4.068 2.4 6.126 2.4m0 7.513c2.058 0 3.726-1.682 3.726-3.756 0-2.075-1.668-3.757-3.726-3.757m11.748 11.687H6.126c-2.058 0-3.726 1.682-3.726 3.756 0 2.075 1.668 3.757 3.726 3.757h11.748m0-7.513c2.058 0 3.726 1.682 3.726 3.756 0 2.075-1.668 3.757-3.726 3.757m0-7.513c-2.058 0-3.726 1.682-3.726 3.756 0 2.075 1.668 3.757 3.726 3.757"
    />
  </svg>
);
export default SvgAudioSettings02;
